import React from 'react';
import { PageHeader } from '@features/shared';
import { usePageInitialization } from '@features/shared/hooks/usePageInitialization';

/**
 * LCD Form Page - Embedded Zoho survey form
 */
const LCDFormPage = () => {
  usePageInitialization();

  return (
    <div>
      <PageHeader title="LCD Form" path="/" />
      <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0 }}>
        <iframe
          src="https://survey.zohopublic.in/zs/i0eO7F"
          title="Infra Page"
          style={{ width: '100%', height: '90%', border: 'none' }}
        />
      </div>
    </div>
  );
};

export { LCDFormPage };
export default LCDFormPage;
